import { useI18n } from "../../lib/i18n.jsx";
import { CONTACT } from "../../lib/content.js";
import { ArrowUpRight } from "lucide-react";

export default function CrossPromo() {
  const { t } = useI18n();
  const cards = [
    {
      href: CONTACT.shop,
      title: t.crosspromo.shop.title,
      body: t.crosspromo.shop.body,
      cta: t.crosspromo.shop.cta,
      img: "/img/sklep.webp",
      testid: "crosspromo-shop"
    },
    {
      href: CONTACT.park,
      title: t.crosspromo.park.title,
      body: t.crosspromo.park.body,
      cta: t.crosspromo.park.cta,
      img: "/img/skatepark.webp",
      testid: "crosspromo-park"
    }
  ];

  return (
    <section
      data-testid="crosspromo-section"
      className="bg-paper py-20 md:py-28"
    >
      <div className="max-w-[1300px] mx-auto px-5 md:px-8">
        <div className="text-center mb-12">
          <p className="font-handwritten text-summer text-2xl md:text-3xl mb-2">
            {t.crosspromo.kicker}
          </p>
          <h2
            className="font-display font-bold text-winter leading-tight"
            style={{ fontSize: "clamp(2rem, 4.5vw, 3.5rem)" }}
          >
            {t.crosspromo.title}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {cards.map((c) => (
            <a
              key={c.href}
              href={c.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={c.testid}
              className="card-soft overflow-hidden group"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img src={c.img} alt={c.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
              </div>
              <div className="p-6 md:p-8 flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-display font-bold text-winter text-2xl md:text-3xl mb-2">{c.title}</h3>
                  <p className="text-winter/65 mb-4">{c.body}</p>
                  <span className="inline-flex items-center gap-1.5 font-semibold text-summer">
                    {c.cta} <ArrowUpRight className="w-4 h-4" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
